<template>
  <react-button 
    v-bind:isReacted="statement.meta.isJybed" 
    v-bind:numReactions="statement.meta.numJybes" 
    v-bind:name="'Jybe'" 
    v-bind:icon="'check-circle'"
    @toggleOn="jybeStatement(); $emit('react')" 
    @toggleOff="unjybeStatement(); $emit('react')"
  />
</template>

<script>
  import JybeButton from "./JybeButton.ts";

  export default JybeButton;
</script>
